export class FeedbackHandler {
  constructor(checkExercise) {
    this.checkExercise = checkExercise;
  }
  handleFeedbackForAnswer(feedback, answer) {
    this.checkExercise(feedback.message, feedback.success, answer.getCommand());
  }
}